import { Link } from '@snack-uikit/link';
import { CONTROL } from '../../../../components';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var networkSpeedValues = [0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 2000, 3000, 5000, 10000];
var OsTypeItem = {
  Desktop: 'Desktop',
  Linux: 'Linux'
};
var osTypeItems = [{
  value: OsTypeItem.Desktop,
  label: 'Десктопная'
}, {
  value: OsTypeItem.Linux,
  label: 'Linux'
}];
var TariffPlanItem = {
  Linux: 'Linux',
  Standard: 'Standard',
  Advanced: 'Advanced'
};
var tariffPlanItems = [{
  value: TariffPlanItem.Linux,
  label: 'Linux',
  description: 'Удаленные рабочие столы будут развернуты на операционной системе Linux'
}, {
  value: TariffPlanItem.Standard,
  label: 'Стандартный',
  description: 'Удаленные рабочие столы будут развернуты на десктопной операционной системе'
}, {
  value: TariffPlanItem.Advanced,
  label: 'Продвинутый',
  description: 'Удаленные рабочие столы будут развернуты на десктопной операционной системе или Linux'
}];
export var VM_WARE_VIRTUAL_WORKSPACES_FORM_CONFIG = {
  ui: [['osType'], 'tariffPlan', ['workSpacesCount'], ['vcpuCount'], ['ramVolume'], ['ssdVolume'], ['videoMemoryVolume'], ['networkSpeed']],
  controls: {
    osType: {
      type: CONTROL.Segmented,
      accessorKey: 'vdi.osType',
      defaultValue: OsTypeItem.Desktop,
      items: osTypeItems,
      decoratorProps: {
        label: 'Операционная система'
      },
      onChangeFn: function onChangeFn(value, setValue) {
        var minRam = value === OsTypeItem.Linux ? 2 : 4;
        setValue([['vdi.osType', value], ['vdi.ramVolume', minRam]]);
      }
    },
    tariffPlan: {
      type: CONTROL.ToggleCards,
      defaultValue: TariffPlanItem.Standard,
      items: tariffPlanItems,
      accessorKey: 'vdi.tariffPlan',
      decoratorProps: {
        label: 'Тарифный план',
        labelTooltip: /*#__PURE__*/_jsxs(_Fragment, {
          children: ["\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043E \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044F\u0445 \u043A\u0430\u0436\u0434\u043E\u0433\u043E", /*#__PURE__*/_jsx("br", {}), "\u0438\u0437 \u0442\u0430\u0440\u0438\u0444\u043E\u0432 \u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u0432", ' ', /*#__PURE__*/_jsx(Link, {
            target: "_blank",
            href: "https://cloud.ru/docs/vdi/ag/topics/tariffs",
            textMode: "accent",
            text: "\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u0438",
            appearance: "invert-neutral"
          })]
        })
      },
      watchedControls: {
        osType: 'vdi.osType'
      },
      relateFn: function relateFn(_ref) {
        var osType = _ref.osType;
        if (osType === OsTypeItem.Linux) {
          return {
            items: tariffPlanItems.filter(function (item) {
              return item.value !== TariffPlanItem.Standard;
            })
          };
        }
        return {
          items: tariffPlanItems.filter(function (item) {
            return item.value !== TariffPlanItem.Linux;
          })
        };
      }
    },
    workSpacesCount: {
      type: CONTROL.Stepper,
      accessorKey: 'vdi.workSpacesCount',
      defaultValue: 1,
      decoratorProps: {
        label: 'Количество рабочих мест'
      },
      uiProps: {
        min: 1,
        max: 2000,
        postfix: 'Шт'
      }
    },
    vcpuCount: {
      type: CONTROL.Stepper,
      accessorKey: 'vdi.vcpuCount',
      defaultValue: 2,
      decoratorProps: {
        label: 'Количество ядер vCPU'
      },
      uiProps: {
        min: 2,
        max: 18,
        postfix: 'Шт'
      }
    },
    ramVolume: {
      type: CONTROL.Stepper,
      accessorKey: 'vdi.ramVolume',
      decoratorProps: {
        label: 'Объем оперативной памяти RAM'
      },
      defaultValue: 2,
      uiProps: {
        min: 4,
        max: 64,
        postfix: 'ГБ'
      },
      watchedControls: {
        osType: 'vdi.osType'
      },
      relateFn: function relateFn(_ref2) {
        var osType = _ref2.osType;
        switch (osType) {
          case OsTypeItem.Linux:
            {
              return {
                uiProps: {
                  min: 2,
                  max: 64
                }
              };
            }
          case OsTypeItem.Desktop:
          default:
            {
              return {
                uiProps: {
                  min: 4,
                  max: 64
                }
              };
            }
        }
      }
    },
    ssdVolume: {
      type: CONTROL.Stepper,
      accessorKey: 'vdi.ssdVolume',
      defaultValue: 40,
      decoratorProps: {
        label: 'Жесткий диск SSD'
      },
      uiProps: {
        min: 40,
        max: 40000,
        postfix: 'ГБ'
      }
    },
    videoMemoryVolume: {
      type: CONTROL.Slider,
      accessorKey: 'vdi.videoMemoryVolume',
      decoratorProps: {
        label: 'Объем видеопамяти A40 vGPU'
      },
      items: [0, 2, 4, 8, 12, 16, 24, 48],
      uiProps: {
        step: 1,
        postfix: 'ГБ'
      }
    },
    networkSpeed: {
      type: CONTROL.Stepper,
      accessorKey: 'vdi.networkSpeed',
      defaultValue: 0,
      decoratorProps: {
        label: 'Скорость доступа в интернет'
      },
      uiProps: {
        min: 0,
        max: 10000,
        postfix: 'Мбит/с',
        allowedValues: networkSpeedValues
      }
    }
  }
};